<template>
    <main class="page_content">
        <section>
            <div class="align-content-center m-4">
                <div class="page_title" style="display: flex;justify-content: center;">
                    <div class="page_title" style="display: flex;justify-content: center;">
                        <div>
                            <h3 class="page_title" style="display: inline-block;
          height: 4.1rem;
          border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">Vlog </h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="page_content">
            <div class="container row">
                <div class="text-left mt-5" v-html="content" ref="myDiv">

                </div>

            </div>

            <div style="height: 50px;">
            </div>

        </section>
    </main>
</template>

<script>
    // import NavigationCard from '@/components/common/TopVideo.vue';
    import { getVlogData } from "@/api/rbac/vlog";
    export default {
        name: 'NewsDetails',
        components: {
            // NavigationCard,
        },
        computed: {
            contentWithBreaks() {
                return this.content.replace(/\\n/g, "\n");
            },
        },
        created() {
            this.getData()
        },
        data() {
            return {
                content: '',
                slides: [],
                activeIndex: 0, // 当前激活的图片索引
            };
        },
        methods: {
            getData() {
                try {
                    getVlogData({ strWhere: ' and a.ID=' + this.$route.params.id }).then((res) => {
                        if (res.data.length == 0) {
                            this.content = '';
                        }
                        else {
                            this.content = res.data[0].content;
                            this.content = this.content.replace(/<p>\s*<span\s+style="color:\s*black;">/gi, `<p><span style="color: white;">`);

                        }

                    });

                } catch (error) {
                    console.log(error);
                }
            },
        },
    };
</script>

<style scoped>
    @import '../../assets/css/main.css';

    :deep(hr) {
        margin-top: 0.3rem;
        border-top: 1px solid #545454;
        margin-bottom: 0.3rem;
    }
</style>